import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M338.823529,57.9661176 L338.823529,280.121412 L0,280.121412 L0,1861.41082 L225.882353,1861.41082 L225.882353,506.116706 L338.823529,506.116706 L338.823529,728.384941 L745.637647,393.175529 L338.823529,57.9661176 Z M1694.23059,506.116706 L1920.11294,506.116706 L1920.11294,280.121412 L1694.23059,280.121412 L1694.23059,506.116706 Z M1355.29412,506.116706 L1581.28941,506.116706 L1581.28941,280.121412 L1355.29412,280.121412 L1355.29412,506.116706 Z M1016.47059,506.116706 L1242.35294,506.116706 L1242.35294,280.121412 L1016.47059,280.121412 L1016.47059,506.116706 Z M677.76,957.881412 L1920.11294,957.881412 L1920.11294,731.999059 L677.76,731.999059 L677.76,957.881412 Z M677.76,1409.64612 L1920.11294,1409.64612 L1920.11294,1183.65082 L677.76,1183.65082 L677.76,1409.64612 Z M677.76,1861.41082 L1920.11294,1861.41082 L1920.11294,1635.52847 L677.76,1635.52847 L677.76,1861.41082 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveUpTopSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveUpTopSolid, _Component);

  var _super = _createSuper(IconMoveUpTopSolid);

  function IconMoveUpTopSolid() {
    _classCallCheck(this, IconMoveUpTopSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveUpTopSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveUpTop",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveUpTopSolid.displayName = "IconMoveUpTopSolid";
  return IconMoveUpTopSolid;
}(Component);

IconMoveUpTopSolid.glyphName = 'move-up-top';
IconMoveUpTopSolid.variant = 'Solid';
IconMoveUpTopSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveUpTopSolid;
export { IconMoveUpTopSolid };